const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/products/index.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/products/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { listProductsQuery } from '@/features/user-products/lib/list-products.query';
export const Route = createFileRoute('/_authenticated/resources/products/')({
  loader: async ({
    context,
    location
  }) => {
    try {
      await context.queryClient.ensureInfiniteQueryData(listProductsQuery({
        controllers: {
          productController: context.deps.controllers.productController
        }
      }));
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});